import { render } from "./MainContainer.vue?vue&type=template&id=f475f9ce&scoped=true"
import script from "./MainContainer.vue?vue&type=script&lang=js"
export * from "./MainContainer.vue?vue&type=script&lang=js"

import "./MainContainer.vue?vue&type=style&index=0&id=f475f9ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f475f9ce"]])

export default __exports__